import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Loading = (props: NovaIconProps) => (
  <Icon
    className="anticon-spin"
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.05"
          d="M16.0006 11C15.4227 11 14.9536 10.552 14.9536 10V5C14.9536 4.448 15.4227 4 16.0006 4C16.5785 4 17.0476 4.448 17.0476 5V10C17.0476 10.552 16.5785 11 16.0006 11Z"
          fill="currentColor"
        />
        <path
          opacity="0.5"
          d="M16.0006 28C15.4227 28 14.9536 27.552 14.9536 27V22C14.9536 21.448 15.4227 21 16.0006 21C16.5785 21 17.0476 21.448 17.0476 22V27C17.0476 27.552 16.5785 28 16.0006 28Z"
          fill="currentColor"
        />
        <path
          opacity="0.1"
          d="M12.3091 12.146C11.9845 12.146 11.6663 12.003 11.4611 11.734L8.38391 7.68901C8.04364 7.24201 8.14736 6.61702 8.61537 6.29202C9.08442 5.96702 9.73772 6.06701 10.078 6.51301L13.1551 10.558C13.4953 11.005 13.3917 11.63 12.9237 11.955C12.7374 12.084 12.5216 12.146 12.3091 12.146Z"
          fill="currentColor"
        />
        <path
          opacity="0.6"
          d="M22.7701 25.8991C22.4455 25.8991 22.1272 25.7561 21.922 25.4871L18.8449 21.4421C18.5046 20.9951 18.6082 20.3701 19.0762 20.0451C19.5463 19.7201 20.1986 19.8201 20.5388 20.2661L23.616 24.3111C23.9563 24.7581 23.8526 25.3831 23.3846 25.7081C23.1993 25.8371 22.9837 25.8991 22.7701 25.8991Z"
          fill="currentColor"
        />
        <path
          opacity="0.2"
          d="M10.0253 15.146C9.91851 15.146 9.80862 15.13 9.70183 15.097L4.72338 13.552C4.17371 13.381 3.87326 12.817 4.05124 12.292C4.22923 11.767 4.82079 11.479 5.37046 11.65L10.3489 13.195C10.8986 13.366 11.199 13.93 11.021 14.455C10.8776 14.878 10.4671 15.146 10.0253 15.146Z"
          fill="currentColor"
        />
        <path
          opacity="0.7"
          d="M26.9532 20.3991C26.8464 20.3991 26.7364 20.3831 26.6296 20.3501L21.6511 18.8051C21.1014 18.6341 20.801 18.0701 20.979 17.5451C21.158 17.0201 21.7475 16.7311 22.2982 16.9031L27.2766 18.4481C27.8263 18.6191 28.1268 19.1831 27.9488 19.7081C27.8053 20.1311 27.395 20.3991 26.9532 20.3991Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M9.22986 25.8991C9.01628 25.8991 8.80173 25.8371 8.61537 25.7081C8.14736 25.3831 8.04364 24.7581 8.38391 24.3111L11.4611 20.2661C11.8024 19.8201 12.4547 19.7201 12.9237 20.0451C13.3917 20.3701 13.4953 20.9951 13.1551 21.4421L10.078 25.4871C9.87278 25.7561 9.55338 25.8991 9.22986 25.8991Z"
          fill="currentColor"
        />
        <path
          opacity="0.9"
          d="M19.6918 12.146C19.4782 12.146 19.2636 12.084 19.0772 11.955C18.6092 11.63 18.5056 11.005 18.8459 10.558L21.9229 6.51301C22.2632 6.06701 22.9176 5.96702 23.3856 6.29202C23.8536 6.61702 23.9573 7.24201 23.617 7.68901L20.5399 11.734C20.3347 12.003 20.0153 12.146 19.6918 12.146Z"
          fill="currentColor"
        />
        <path
          opacity="0.3"
          d="M5.04686 20.3991C4.60503 20.3991 4.19573 20.1301 4.05124 19.7081C3.87326 19.1831 4.17371 18.6191 4.72338 18.4481L9.70183 16.9031C10.2536 16.7311 10.842 17.0201 11.021 17.5451C11.199 18.0701 10.8986 18.6341 10.3489 18.8051L5.37046 20.3501C5.26367 20.3841 5.15365 20.3991 5.04686 20.3991Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M21.9747 15.1459C21.5329 15.1459 21.1235 14.8769 20.979 14.4549C20.801 13.9299 21.1014 13.3659 21.6511 13.1949L26.6296 11.6499C27.1803 11.4779 27.7697 11.7669 27.9488 12.2919C28.1268 12.8169 27.8263 13.3809 27.2766 13.5519L22.2982 15.0969C22.1914 15.1299 22.0815 15.1459 21.9747 15.1459Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Loading
